import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingService } from './services/loading.service';
import { CommonModule } from '@angular/common';
import { NotificationService } from './services/notification.service';
import { AuthService } from './services/auth.service';
import { BackNavigationService } from './services/back-navigation.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
})
export class AppComponent {
  loading = false;

  constructor(
    private loaderService: LoadingService,
    private cdr: ChangeDetectorRef,
    private notification: NotificationService,
    private authService: AuthService,
    private backNavigation: BackNavigationService,
  ) {
    this.notification.requestPermission();
    this.notification.listen();
    this.loaderService.loading$.subscribe((isLoading) => {
      setTimeout(() => {
        this.loading = isLoading;
      });
      this.cdr.markForCheck();
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const backControl = target.closest<HTMLElement>('[data-app-back]');
    if (!backControl) return;

    event.preventDefault();
    this.backNavigation.back(backControl.dataset['backFallback'] || '/');
  }

  // @HostListener('window:beforeunload')
  // onBeforeUnload(): void {
  //   this.authService.logout();
  // }
}
